import { render } from "./UserPicker.html?vue&type=template&id=c4c9c096&scoped=true&ts=true"
import script from "./UserPicker.ts?vue&type=script&lang=ts"
export * from "./UserPicker.ts?vue&type=script&lang=ts"

import "./UserPicker.scss?vue&type=style&index=0&id=c4c9c096&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4c9c096"]])

export default __exports__